import React from "react";
import styled from "@emotion/styled";
import { Icon } from "../Icon";
import { Text } from "../Text";

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 70vh;
  justify-content: center;
`;

const LoadingText = styled(Text)`
  margin-top: 16px;
`;

export type PageLoadingIndicatorProps = {
  text?: string;
};

export function PageLoadingIndicator({
  text = "Loading...",
}: PageLoadingIndicatorProps) {
  return (
    <Container>
      <Icon isCenter type="loading" />
      <LoadingText isCenter>{text}</LoadingText>
    </Container>
  );
}
